import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=f1dd470e&scoped=true&"
import script from "./LoginHistory.vue?vue&type=script&lang=ts&"
export * from "./LoginHistory.vue?vue&type=script&lang=ts&"
import style0 from "./LoginHistory.vue?vue&type=style&index=0&id=f1dd470e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dd470e",
  null
  
)

export default component.exports